export default __webpack_public_path__ + "static/media/flips_slider_2018_with_book1.1149372f.png";